import {Request} from "../core/request";
import {AuthHeader} from "../core/token";



export async function getMarkTerminateUsers() {
    return await Request.get("/super_admin/users/resignations/mark", {headers: AuthHeader()});
}

export async function getTerminateUsers() {
    return await Request.get("/super_admin/users/resignations", {headers: AuthHeader()});
}


export async function markTerminate(userId: number){
    return await Request.post('/super_admin/users/resignation/mark', {user_id: userId}, {headers: AuthHeader()})
}


export async function unmarkTerminate(userId: number){
    return await Request.post('/super_admin/users/resignation/unMark', {user_id: userId}, {headers: AuthHeader()})
}

export async function realTerminate(userId: number){
    return await Request.post('/super_admin/users/resignation/real', {user_id: userId}, {headers: AuthHeader()})
}
